import React, { Component } from "react";

class ShowForm extends Component {
  render() {
    return (
      <>
        <div className={this.props.workingModal ? "" : "hide"}>
          <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
            CARGANDO INFORMACIÓN
          </div>
        </div>

        <div className={this.props.workingModal ? "hide" : ""}>
          <fieldset className="col-md-12">
            <legend>INFORMACIÓN RECETA</legend>

            {/* <div className="container"> */}
            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label>Razón social del establecimiento:</label>
                  <div className="form-control">
                    {this.props.receta_electronica.establecimiento
                      ? this.props.receta_electronica.establecimiento.razon_social.toUpperCase()
                      : "N/A"}
                  </div>
                </div>
              </div>
            </div>

            <hr />

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Nombre comercial del producto:</label>
                  <div className="form-control">
                    {this.props.receta_electronica.producto
                      ? `${this.props.receta_electronica.producto.nombre_comercial} (${this.props.receta_electronica.producto.no_registro})`
                      : "N/A"}
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label>Presentación:</label>
                  <div className="form-control">
                    {this.props.receta_electronica.presentacion
                      ? `${this.props.receta_electronica.presentacion.empaque.toUpperCase()} (${
                          this.props.receta_electronica.presentacion.cantidad
                        }${
                          this.props.receta_electronica.presentacion
                            .unidad_medida
                        })`
                      : "N/A"}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Cantidad (número):</label>
                  <div className="form-control">
                    {this.props.receta_electronica.cant_num}
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label>Cantidad (texto):</label>
                  <div className="form-control">
                    {this.props.receta_electronica.cant_texto}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Fabricante del producto:</label>
                  <div className="form-control">
                    {this.props.receta_electronica.fabricante
                      ? this.props.receta_electronica.fabricante.razon_social.toUpperCase()
                      : "N/A"}
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label>País de origen del producto:</label>
                  <div className="form-control">
                    {this.props.receta_electronica.pais_origen_prod}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>
                    Nombre del propietario del animal o los animales a tratar:
                  </label>
                  <div className="form-control">
                    {this.props.receta_electronica.nombre_propietario_animal}
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label>
                    Dirección del propietario del animal o los animales a
                    tratar:
                  </label>
                  <div className="form-control">
                    {this.props.receta_electronica.direccion_propietario_animal}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Razón social de la explotación pecuaria:</label>
                  <div className="form-control">
                    {this.props.receta_electronica
                      .razon_social_explotacion_pecuaria
                      ? this.props.receta_electronica
                          .razon_social_explotacion_pecuaria
                      : "N/A"}
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label>Dirección de la explotación pecuaria:</label>
                  <div className="form-control">
                    {this.props.receta_electronica
                      .direccion_explotacion_pecuaria
                      ? this.props.receta_electronica
                          .direccion_explotacion_pecuaria
                      : "N/A"}
                  </div>
                </div>
              </div>
            </div>

            <hr />

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Cantidad a tratar:</label>
                  <div className="form-control">
                    {this.props.receta_electronica.rel_receta_dosis
                      ? this.props.receta_electronica.rel_receta_dosis
                          .cantidad_tratar
                      : "N/A"}
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Dosis por especie:</label>
                  <div className="form-control">
                    {this.props.receta_electronica.rel_receta_dosis &&
                    this.props.receta_electronica.rel_receta_dosis.dosis
                      ? `${
                          this.props.receta_electronica.rel_receta_dosis.dosis[
                            "dosis"
                          ]
                        } - ${this.props.receta_electronica.rel_receta_dosis.dosis[
                          "especie_texto"
                        ].toUpperCase()} (${
                          this.props.receta_electronica.rel_receta_dosis.dosis[
                            "categoria_texto"
                          ]
                            ? this.props.receta_electronica.rel_receta_dosis.dosis[
                                "categoria_texto"
                              ].toUpperCase()
                            : "SIN CATEGORÍA"
                        })`
                      : "N/A"}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-2">
                <div className="form-group">
                  <label>Frecuencia:</label>
                  <div className="form-control">
                    {this.props.receta_electronica.rel_receta_dosis
                      ? this.props.receta_electronica.rel_receta_dosis
                          .frecuencia
                      : "N/A"}
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="form-group">
                  <label>Medida del tiempo de la frecuencia:</label>
                  <div className="form-control">
                    {this.props.receta_electronica.rel_receta_dosis
                      ? this.props.receta_electronica.rel_receta_dosis
                          .medida_frecuencia
                      : "N/A"}
                  </div>
                </div>
              </div>

              <div className="col-lg-2">
                <div className="form-group">
                  <label>Tratamiento:</label>
                  <div className="form-control">
                    {this.props.receta_electronica.rel_receta_dosis
                      ? this.props.receta_electronica.rel_receta_dosis
                          .tratamiento
                      : "N/A"}
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="form-group">
                  <label>Unidad del tiempo del tratamiento:</label>
                  <div className="form-control">
                    {this.props.receta_electronica.rel_receta_dosis
                      ? this.props.receta_electronica.rel_receta_dosis
                          .medida_tratamiento
                      : "N/A"}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label>Período de retiro:</label>
                  <div className="form-control">
                    {this.props.receta_electronica.rel_receta_dosis &&
                    this.props.receta_electronica.rel_receta_dosis
                      .producto_descarte
                      ? `${
                          this.props.receta_electronica.rel_receta_dosis
                            .producto_descarte["periodo"]
                        } ${this.props.receta_electronica.rel_receta_dosis.producto_descarte[
                          "medida_tiempo_texto"
                        ].toUpperCase()} - ${this.props.receta_electronica.rel_receta_dosis.producto_descarte[
                          "especie_producto_texto"
                        ].toUpperCase()}`
                      : "N/A"}
                  </div>
                </div>
              </div>
            </div>
            {/* </div> */}
          </fieldset>
        </div>
      </>
    );
  }
}

export default ShowForm;
